import { useState } from 'react';
import { Carousel } from 'react-responsive-carousel';
import { apps } from '../../data/apps';
import { Reveal } from '../ui/Reveal';
import { SectionHeading } from '../ui/SectionHeading';
import { AndroidIcon, AppleIcon } from '../ui/PlatformIcons';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

const PLATFORMS = [
  { id: 'android', name: 'Android', Icon: AndroidIcon },
  { id: 'ios', name: 'iOS', Icon: AppleIcon },
];

export const Showcase = ({ t }) => {
  const [platform, setPlatform] = useState('android');
  const shown = apps.filter((app) => app.platform === platform);

  return (
    <section className="section showcase">
      <Reveal>
        <SectionHeading eyebrow={t('showcase.eyebrow')} title={t('showcase.title')} align="center" />
      </Reveal>

      <div className="showcase__layout">
        <div className="feature-cloud feature-cloud--left">
          {t('showcase.features').slice(0, 4).map((feature, index) => (
            <Reveal key={feature} delay={index * 70}><div className="feature-pill">{feature}</div></Reveal>
          ))}
        </div>

        <Reveal className="phone-reveal" delay={100}>
          <div className="showcase__stage">
            <div className="platform-switch" role="tablist" aria-label={t('showcase.switchLabel')}>
              <span
                className="platform-switch__thumb"
                style={{ transform: `translateX(${platform === 'ios' ? 100 : 0}%)` }}
                aria-hidden="true"
              />
              {PLATFORMS.map((item) => (
                <button
                  key={item.id}
                  type="button"
                  role="tab"
                  aria-selected={platform === item.id}
                  className={`platform-switch__option ${platform === item.id ? 'is-active' : ''}`}
                  onClick={() => setPlatform(item.id)}
                >
                  <item.Icon />
                  <span>{item.name}</span>
                </button>
              ))}
            </div>

            <div className={`device device--${platform}`}>
              <span className="device__glow" aria-hidden="true" />
              <div className="device__frame">
                <div className="device__screen">
                  <Carousel
                    key={platform}
                    autoPlay
                    infiniteLoop
                    interval={2400}
                    showArrows={false}
                    showIndicators={false}
                    showStatus={false}
                    showThumbs={false}
                    stopOnHover={false}
                    swipeable
                  >
                    {shown.map((app) => <img key={app.name} src={app.image} alt={app.name} />)}
                  </Carousel>
                  <span className="device__notch" aria-hidden="true" />
                  <span className="device__gloss" aria-hidden="true" />
                </div>
              </div>
            </div>
          </div>
        </Reveal>

        <div className="feature-cloud feature-cloud--right">
          {t('showcase.features').slice(4).map((feature, index) => (
            <Reveal key={feature} delay={index * 70}><div className="feature-pill">{feature}</div></Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
